import React, { createContext, useMemo, useState } from 'react';

import { ContextProps } from 'context/type';
import { ITruckerProfileProps } from 'interfaces/profile.interface';
import { SearchTruckerContextProps } from './types';

export const SearchTruckerContext = createContext({} as SearchTruckerContextProps);

export const SearchTruckerProvider = ({ children }: ContextProps) => {
  const [valueInputSearch, setValueInputSearch] = useState<string | null>('');
  const [isInputSearchMasked, setIsInputSearchMasked] = useState(false);
  const [isTextFieldFocus, setIsTextFieldFocus] = useState(false);
  const [isCardVisible, setIsCardVisible] = useState(false);
  const [isEmpty, setIsEmpty] = useState(false);
  const [isNotActive, setIsNotActive] = useState(false);
  const [isBenefitsModalOpen, setIsBenefitsModalOpen] = useState(false);
  const [isModalJourneyVisible, setIsModalJourneyVisible] = useState(false);
  const [isProfileVisible, setIsProfileVisible] = useState(false);
  const [isDivergence, setIsDivergence] = useState(false);
  const [inputHasError, setInputHasError] = useState(false);
  const [isLoadingRequest, setIsLoadingRequest] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isJourneyAvailable, setIsJourneyAvailable] = useState(true);
  const [openSearchWidth, setOpenSearchWidth] = useState<number>(null);
  const [isModalShareFreightVisible, setIsModalShareFreightVisible] = useState(false);
  const [freightIdToShare, setFreightIdToShare] = useState<string>(null);
  const [truckerId, setTruckerId] = useState<string>(null);
  const [isLastSearchedDriversVisible, setIsLastSearchedDriversVisible] = useState(false);
  const [isKebabVisible, setIsKebabVisible] = useState(false);
  const [isLastSearchedDrivers, setIsLastSearchedDrivers] = useState(false);
  const [refetchSearch, setRefetchSearch] = useState<() => void>(null);
  const [searchTruckerData, setSearchTruckerData] = useState<ITruckerProfileProps>(null);

  const contextValue = useMemo(
    () => ({
      valueInputSearch,
      isInputSearchMasked,
      isTextFieldFocus,
      isCardVisible,
      isEmpty,
      isNotActive,
      isBenefitsModalOpen,
      isModalJourneyVisible,
      isProfileVisible,
      isDivergence,
      inputHasError,
      isLoadingRequest,
      isError,
      isJourneyAvailable,
      openSearchWidth,
      isModalShareFreightVisible,
      truckerId,
      isLastSearchedDriversVisible,
      isKebabVisible,
      freightIdToShare,
      isLastSearchedDrivers,
      searchTruckerData,
      refetchSearch,
      setIsEmpty,
      setIsNotActive,
      setIsBenefitsModalOpen,
      setValueInputSearch,
      setIsInputSearchMasked,
      setIsTextFieldFocus,
      setIsCardVisible,
      setIsModalJourneyVisible,
      setIsProfileVisible,
      setIsDivergence,
      setInputHasError,
      setIsLoadingRequest,
      setIsError,
      setRefetchSearch,
      setIsJourneyAvailable,
      setOpenSearchWidth,
      setIsModalShareFreightVisible,
      setTruckerId,
      setIsLastSearchedDriversVisible,
      setIsKebabVisible,
      setFreightIdToShare,
      setIsLastSearchedDrivers,
      setSearchTruckerData,
    }),
    [
      valueInputSearch,
      isTextFieldFocus,
      isCardVisible,
      isEmpty,
      isNotActive,
      isBenefitsModalOpen,
      isModalJourneyVisible,
      isProfileVisible,
      isDivergence,
      inputHasError,
      isLoadingRequest,
      isError,
      isJourneyAvailable,
      openSearchWidth,
      isModalShareFreightVisible,
      truckerId,
      isLastSearchedDriversVisible,
      isKebabVisible,
      freightIdToShare,
      isLastSearchedDrivers,
      searchTruckerData,
      refetchSearch,
    ]
  );

  return <SearchTruckerContext.Provider value={contextValue}>{children}</SearchTruckerContext.Provider>;
};
